module.exports = __webpack_public_path__ + "img/thumb-004-01.15e8e681.png";